'use client';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ImageProps } from '@repo/ui/src/types/image';
import { classNames } from '@repo/ui/src/utils/classNames';
import Button from '@repo/ui/src/components/Button';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { AmplienceButtonProps } from '@repo/ui/src/types/button';
import { getButtonVariant } from '@repo/ui/src/components/Button/utils';
import Image from 'next/image';

export interface QuoteProps {
  text: string;
  quoteAuthor?: string;
  profileStyle: boolean;
  image: ImageProps;
  button: AmplienceButtonProps;
}

const Quote = ({ text, quoteAuthor, profileStyle, image, button }: QuoteProps) => {
  const imgUrl = buildImageSrc(image, 300, 0, 0);

  return (
    <div className="tw-w-full tw-grid tw-gap-8 tw-my-8 tw-mx-4 sm:tw-mx-12 tw-flex-col sm:tw-grid-flow-col tw-content-center tw-place-items-center">
      <div
        className={classNames(
          'tw-hidden md:tw-flex tw-items-center tw-relative tw-aspect-square tw-w-full tw-min-w-40',
          profileStyle ? 'tw-rounded-full' : '',
        )}
      >
        <Image
          src={imgUrl}
          alt={`${quoteAuthor} Logo`}
          fill
          className={classNames(
            'tw-mb-10 tw-object-contain',
            profileStyle ? 'tw-rounded-full tw-w-40' : 'tw-w-24',
          )}
        />
      </div>
      <div className="tw-flex tw-flex-col tw-content-center sm:tw-content-start tw-max-w-screen-sm">
        {text && (
          <h3
            className={classNames(
              'tra-text-web-heading-3 tw-text-center md:tw-text-left',
              !!(quoteAuthor || button?.link?.displayName) && 'tw-mb-6',
            )}
          >
            {`"${text}"`}
          </h3>
        )}
        {quoteAuthor && (
          <h6
            className={classNames(
              'tw-text-center md:tw-text-left',
              !!button?.link?.displayName && 'tw-mb-6',
            )}
          >
            &mdash; {quoteAuthor}
          </h6>
        )}
        {button?.link?.displayName && (
          <div className="tw-flex tw-content-center sm:tw-content-start">
            <Button
              {...button.link}
              variant={getButtonVariant(button.style, button.icon)}
              as={Anchor}
              dark
            >
              {button.link.displayName}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Quote;
